export default {"id":"4b3df9fa","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}